import React from "react";
import { format } from "date-fns";
import { startCase } from "lodash";
import { Link } from "react-router-dom";
import { Header, Grid } from "semantic-ui-react";

import { DateFormat } from "../helpers";
import { parseServerTimestampForClient } from "../../common/helpers";
import { buildInvoiceNumberWithBeer } from "utilities/dist/invoice/helpers";
import { formatAmount } from "utilities/dist/helpers";

export const InvoiceComponentSummarizedList = ({
    invoices,
    isCustomerInvoiceNumberingActive = false,
}) => {
    return (
        <>
            {invoices.map(inv => {
                const invoiceNumber = buildInvoiceNumberWithBeer(
                    inv,
                    isCustomerInvoiceNumberingActive
                );
                return (
                    <Grid key={`recent_invoice_${inv.id}`} divided>
                        <Grid.Row columns={2}>
                            <Grid.Column>
                                <Header as="h5">
                                    <Link to={`/invoice/${invoiceNumber}`}>
                                        <Header.Content>#{invoiceNumber}</Header.Content>
                                    </Link>
                                    <Header.Subheader>
                                        {format(
                                            parseServerTimestampForClient(inv.invoiced_at),
                                            DateFormat
                                        )}{" "}
                                        | {formatAmount(inv.total)}
                                    </Header.Subheader>
                                </Header>
                            </Grid.Column>
                            <Grid.Column>
                                <Header as="h5">
                                    <Header.Content>
                                        {startCase(inv.customer?.name || "Unknown Customer")}
                                        <Header.Subheader>
                                            {inv.customer?.address || "Unknown customer address"}
                                        </Header.Subheader>
                                    </Header.Content>
                                </Header>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                );
            })}
        </>
    );
};
